import { Link, Outlet, useParams } from 'react-router';
import PropTypes from 'prop-types';
import { CubeTransparentIcon, ChevronRightIcon } from '@heroicons/react/24/outline';
import { parseCategories } from '@/utils/paramsUtils';
import NodeForm from './NodeForm';
import { useCaseNode, useCaseNodeParams, useCustomModel, useNode, useNodeParams } from '@/stores/nodeStore';
import { fetchDerivedValues, updateNodeParams } from '@/utils/nodeUtils';
import ParamsProvider from '../providers/ParamProvider';
import DynamicConnectorControls from './DynamicConnectorControls';

const NodeFormContent = ({ nodeId, actions, locked }) => {
  const { projectId } = useParams();
  const caseParams = useCaseNodeParams();
  const caseNode = useCaseNode();
  const node = useNode();
  const customModel = useCustomModel();
  const nodeParams = useNodeParams();
  const categories = parseCategories(nodeParams);

  if (node.description || customModel?.is_creator) {
    categories.Description = {
      categoryName: 'Info',
      params: [],
    };
  }

  const hasInternals = caseNode.internal_pathway_id && caseNode.internal_case_id;
  const combinedActions = (
    <>
      {hasInternals ? (
        <Link
          to={`/projects/${projectId}/build/pathways/${caseNode.internal_pathway_id}/${caseNode.internal_case_id}`}
          className="inline-flex items-center gap-1.5 text-sm font-medium text-blue-600 hover:text-blue-700 bg-blue-50 hover:bg-blue-100 border border-blue-200 hover:border-blue-300 rounded-md px-3 py-1"
        >
          <CubeTransparentIcon className="h-4 w-4 shrink-0" />
          <span>Edit Module Internals</span>
          <ChevronRightIcon className="h-3.5 w-3.5 shrink-0" />
        </Link>
      ) : null}
      {actions}
    </>
  );

  return (
    <ParamsProvider readOnly={locked} patch={updateNodeParams} fetchDerivedValues={fetchDerivedValues}>
      <NodeForm
        key={nodeId}
        actions={combinedActions}
        title={node.label}
        description={node.description}
        caseParams={caseParams}
        categories={categories}
        connectorControls={<DynamicConnectorControls nodeId={nodeId} locked={locked} />}
      />
      <div className="absolute w-full top-0 z-1000 bg-white">
        <Outlet />
      </div>
    </ParamsProvider>
  );
};

NodeFormContent.propTypes = {
  nodeId: PropTypes.string.isRequired,
  actions: PropTypes.node.isRequired,
  locked: PropTypes.bool.isRequired,
};

export default NodeFormContent;
